import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import ClampLines from 'react-clamp-lines';
import _ from 'lodash';
import PlanModal from './modal';
import styles from './styles.module.scss';

export default class PlanCard extends Component {
  static defaultProps = {
    detailsButtonText: 'View More',
    ctaButtonText: 'Purchase',
    detailsButtonType: 'modal',
  };

  static propTypes = {
    plan: PropTypes.shape({
      title: PropTypes.string,
      image_file_name: PropTypes.string,
      instruction_hours: PropTypes.number,
      price: PropTypes.number,
      instructor_intro: PropTypes.string,
      benefits: PropTypes.arrayOf(PropTypes.string),
      quantity_remaining: PropTypes.number,
      short_target_audience: PropTypes.string,
    }),
    detailsButtonText: PropTypes.string,
    onCtaClick: PropTypes.func,
    ctaButtonText: PropTypes.string,
    className: PropTypes.string,
    detailsButtonType: PropTypes.oneOf(['link', 'modal']),
  };

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      forceHover: false,
      redirectToPage: false,
    };

    this.onDetailsButtonClick = this.onDetailsButtonClick.bind(this);
    this.toggleForceHover = this.toggleForceHover.bind(this);
    this.toggleModalOpen = this.toggleModalOpen.bind(this);
    this.onCtaClick = this.onCtaClick.bind(this);
    this.closeModalForCta = this.closeModalForCta.bind(this);
  }

  onDetailsButtonClick(e) {
    e.stopPropagation();
    const { detailsButtonType } = this.props;

    if (e.type === 'click' || e.key === 'Enter') {
      if (detailsButtonType === 'modal') {
        this.toggleModalOpen();
      }
      if (detailsButtonType === 'link') {
        this.setState({ redirectToPage: true });
      }
    }
  }

  toggleForceHover(e) {
    e.stopPropagation();
    if (e.type === 'mouseenter') this.setState({ forceHover: true });
    if (e.type === 'mouseleave') this.setState({ forceHover: false });
    if (e.type === 'click')
      this.setState(prevState => ({ forceHover: !prevState.forceHover }));
  }

  toggleModalOpen(e) {
    if (e) e.stopPropagation();
    if (this.props.detailsModalOpen) {
      this.props.onDetailsModalClose();
    } else {
      this.setState(prevState => ({ modalOpen: !prevState.modalOpen }));
    }
  }

  closeModalForCta(e) {
    e.stopPropagation();
    const { onCtaClick } = this.props;
    this.setState(
      prevState => ({ modalOpen: !prevState.modalOpen }),
      onCtaClick,
    );
  }

  onCtaClick(e) {
    e.stopPropagation();
    this.props.onCtaClick();
  }

  render() {
    const {
      plan,
      onCtaClick,
      detailsButtonText,
      detailsButtonType,
      ctaButtonText,
      className,
      linkLearningCenter,
      detailsModalOpen,
      linkPrefix,
    } = this.props;
    const {
      title,
      image_file_name: image,
      instruction_hours: instructionHours,
      price,
      instructor_intro: instructorIntro,
      quantity_remaining: quantityRemaining,
      short_target_audience: shortTargetAudience,
      options,
    } = plan;
    const { forceHover, modalOpen, redirectToPage } = this.state;
    return (
      <div
        className={`${styles.planCard} ${className}`}
        role="button"
        tabIndex="0"
        onKeyPress={this.onDetailsButtonClick}
        onMouseEnter={this.toggleForceHover}
        onMouseLeave={this.toggleForceHover}
      >
        {redirectToPage && linkLearningCenter && (
          <Redirect
            to={`${linkPrefix}/${plan.slug || plan.id}/${linkLearningCenter}`}
          />
        )}
        {redirectToPage && !linkLearningCenter && (
          <Redirect to={`${linkPrefix}/${plan.slug || plan.id}`} />
        )}
        <div className={styles.coreDetails}>
          <div className={styles.detailRow}>
            {detailsButtonType === 'link' ? (
              <Link
                to={`${linkPrefix}/${plan.slug || plan.id}${
                  linkLearningCenter ? '/' + linkLearningCenter : ''
                }`}
              >
                <h3 className={styles.planTitle}>{title}</h3>
              </Link>
            ) : (
              <h3 className={styles.planTitle}>{title}</h3>
            )}
            <h5 className={styles.price}>${price}</h5>
          </div>
          <div className={styles.detailRow}>
            <h6 className={styles.targetAudience}>{shortTargetAudience}</h6>
            <h6 className={styles.instructionHours}>
              {instructionHours} hours
            </h6>
          </div>
          {quantityRemaining !== null && (
            <div className={styles.limitedQuantityRow}>
              <h5 className={styles.limitedQuantity}>
                Only {quantityRemaining} total slots left!
              </h5>
            </div>
          )}
          {quantityRemaining === null &&
            _.some(options, option =>
              _.some(option.choices, choice => choice.quantity_remaining),
            ) && (
              <div className={styles.limitedQuantityRow}>
                <h5 className={styles.limitedQuantity}>Space limited!</h5>
              </div>
            )}
          {instructorIntro && (
            <blockquote className={styles.instructorIntro}>
              <ClampLines
                id="instructor-intro"
                text={instructorIntro}
                lines={2}
                innerElement="p"
                buttons={false}
              />
            </blockquote>
          )}
        </div>
        <div className={styles.imageContainer}>
          <img src={image} className={styles.planImage} alt="" />
          <div
            className={classNames({
              [styles.actionBar]: true,
              [styles.collapsed]: !forceHover,
            })}
          >
            <FontAwesomeIcon
              icon="arrow-down"
              fixedWidth
              className={classNames({
                [styles.collapseIndicator]: true,
                [styles.collapsed]: !forceHover,
              })}
              onClick={this.toggleForceHover}
            />
            {forceHover && (
              <div className={styles.actions}>
                <button
                  type="button"
                  className={styles.planCta}
                  onClick={this.onDetailsButtonClick}
                >
                  {detailsButtonText}
                </button>
                {onCtaClick && (
                  <button
                    type="button"
                    className={styles.secondaryCta}
                    onClick={this.onCtaClick}
                  >
                    {ctaButtonText}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
        {(detailsModalOpen || modalOpen) && (
          <PlanModal
            plan={plan}
            isOpen={detailsModalOpen || modalOpen}
            onClose={this.toggleModalOpen}
            onCtaClick={this.closeModalForCta}
          />
        )}
      </div>
    );
  }
}
